import { IDeliveryAddress } from './deliveryAddress';

export class IDeliveryContact {
   _id: string;
   firstName: string;
   lastName: string;
   email: string;
   contact: string;
   deliveryAddress: IDeliveryAddress;
}